import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { observer } from 'mobx-react-lite';
import { Swiper as SwiperClass } from 'swiper/types';
import StickyLinkButton from '@features/productPreview/sections/StickyBar/components/StickyLinkButton/StickyLinkButton';
import { STICKYBAR_MAP, VisibleSectionType } from '@features/productPreview/const';
import { productPageState } from '@features/productPreview/mobX/state/context';
type PropTypes = {
  stickyBarLinks: Array<string>;
};
const StickyMobileSlider = ({
  stickyBarLinks
}: PropTypes) => {
  const state = productPageState;
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass>();
  useEffect(() => {
    if (state.actualVisibleSection) {
      const activeIndex = stickyBarLinks.indexOf(state.actualVisibleSection);
      swiperInstance?.slideTo(activeIndex);
    }
  }, [state.actualVisibleSection, swiperInstance]);
  return <Swiper slidesPerView="auto" onSwiper={setSwiperInstance}>
      {stickyBarLinks.map((link: string) => VisibleSectionType[link]).filter((type: VisibleSectionType) => type !== null).map((type: VisibleSectionType) => {
      if (!STICKYBAR_MAP.get(type)) {
        return null;
      }
      return <SwiperSlide key={type}>
              <StickyLinkButton type={type} />
            </SwiperSlide>;
    })}
    </Swiper>;
};
export default observer(StickyMobileSlider);